import CryptoJS from "crypto-js";

const { REACT_APP_ENCRYPT_KEY } = process.env;

export const encryptPassword = (password) => {
  let encryptedPassword = CryptoJS.SHA512(password, REACT_APP_ENCRYPT_KEY).toString();
  return encryptedPassword;
};